/* eslint-disable*/
export { default as AuthService } from './AuthService';
export { default as CampaignService } from './CampaignService';
export { default as CartService } from './CartService';
export { default as CustomerService } from './CustomerService';
// deprecated 22Feb2023 - Dinh Tran
// export { default as ExportSerivce } from './ExportService';
export { default as OrderService } from './OrderService';
export { default as PricingService } from './PricingService';
// deprecated 22Feb2023 - Dinh Tran
// export { default as ProductService } from './ProductService';
export { default as ProductServiceV2 } from './ProductServiceV2';
export { default as PromoService } from './PromoService';
export { default as RewardsService } from './RewardsService';
export { default as SellerService } from './SellerService';
export { default as SmartRecommendationService } from './SmartRecommendationService';
export * from './SsrService';
export { default as UserService } from './UserService';
export { default as WebService } from './WebService';
export { default as MarketingService } from './MarketingService';
